import TintOverlayView from "../../../google_maps/tint_overlay_view"

export default class Map {
  constructor(options = {}) {
    const { lat, lng } = options
    const zoom = parseInt(options.zoom)

    const mapId = options.element.dataset.mapId
    this.gMap = new google.maps.Map(options.element, {
      zoom,
      center: { lat, lng },
      mapTypeId: options.mapType,
      mapId,
      disableDefaultUI: true,
      keyboardShortcuts: false,
      zoomControl: false,
      cameraControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: true,
      fullscreenControl: true
    })
    this.gMap.setTilt(0);

    const tintOverlay = new TintOverlayView();
    tintOverlay.setMap(this.gMap);
  }
}
